<template>
  <v-layout row wrap>
    <v-flex xs12 v-if="questionnaires_loaded">
      <v-container v-for="questionnaire in questionnaires" :key="questionnaire.id">
        <v-toolbar-title>Cuestionario: {{ questionnaire.title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-expansion-panels multiple hover>
          <v-expansion-panel
            v-for="(val, key) in questionnaire.pairs"
            :key="key"
          >
            <v-expansion-panel-header>{{key}}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <questionnaire-answer :pairs="val" />            
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>        
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
  import QuestionnaireAnswer from '../components/QuestionnaireAnswer';
  import { mapState } from 'vuex';

  export default {
    name: 'Questionnaire',
    components: {
      QuestionnaireAnswer
    },
    props: ['user_id'],
    data() {
      return {
        questionnaires_loaded: false
      }
    },
    mounted () {
      this.$store.commit('users/setQuestionnaires', []);
      this.$store.dispatch('users/getQuestionnaires', this.user_id);
    },
    computed: {
      ...mapState('users', {
        questionnaires: state => state.questionnaires
      })
    },
    watch: {
      questionnaires(newValue) {
        this.questionnaires_loaded = Array.isArray(newValue) && newValue.length;
      }
    }
  }
</script> 